import { buildCoursePrompt } from "./aiPrompts";

const COURSE_1_CHAR_LIMIT = 1000;
const COURSE_2_CHAR_LIMIT = 1000;
const COURSE_3_CHAR_LIMIT = 1000;
const COURSE_4_CHAR_LIMIT = 1000;
const COURSE_5_CHAR_LIMIT = 1000;
const COURSE_6_CHAR_LIMIT = 1000;
const COURSE_7_CHAR_LIMIT = 1000;
const COURSE_8_CHAR_LIMIT = 1000;

const COURSE_CHAR_LIMITS = [
  null,
  COURSE_1_CHAR_LIMIT,
  COURSE_2_CHAR_LIMIT,
  COURSE_3_CHAR_LIMIT,
  COURSE_4_CHAR_LIMIT,
  COURSE_5_CHAR_LIMIT,
  COURSE_6_CHAR_LIMIT,
  COURSE_7_CHAR_LIMIT,
  COURSE_8_CHAR_LIMIT,
];

export const COURSE_CONFIG = (courseNum) => ({
  systemPrompt: buildCoursePrompt(COURSE_CHAR_LIMITS[courseNum]),
  getStudentReportInfo: (v) => {
    const p = `course${courseNum}`;
    return {
      [`${p}Title`]: v[`${p}Title`],
      [`${p}Code`]: v[`${p}Code`],
      [`${p}FirstPercentageMark`]: v[`${p}FirstPercentageMark`],
      [`${p}FinalPercentageMark`]: v[`${p}FinalPercentageMark`],
      [`${p}FinalClassesMissed`]: v[`${p}FinalClassesMissed`],
      [`${p}FinalTimesLate`]: v[`${p}FinalTimesLate`],
      [`${p}FinalResponsibility`]: v[`${p}FinalResponsibility`],
      [`${p}FinalOrganization`]: v[`${p}FinalOrganization`],
      [`${p}FinalIndependentWork`]: v[`${p}FinalIndependentWork`],
      [`${p}FinalCollaboration`]: v[`${p}FinalCollaboration`],
      [`${p}FinalInitiative`]: v[`${p}FinalInitiative`],
    };
  },
});
